// Shared between Leads.js (list badges + default sort) and LeadDetail.js
// (banner) so the two views can never disagree about what "overdue" means.
const todayISO = () => new Date().toISOString().slice(0, 10);

export const getLeadUrgency = (lead) => {
  if (!lead.next_follow_up_date) return { key: 'none', label: 'No Follow-Up Set', rank: 3 };
  const due = lead.next_follow_up_date;
  const today = todayISO();
  if (due < today) return { key: 'overdue', label: 'Overdue', rank: 0 };
  if (due === today) return { key: 'today', label: 'Due Today', rank: 1 };
  return { key: 'upcoming', label: 'Upcoming', rank: 2 };
};

// Composite sort key: rank first (overdue before today before upcoming
// before unset), then soonest date within a rank.
export const getLeadUrgencySortValue = (lead) => {
  const urgency = getLeadUrgency(lead);
  const dateRank = lead.next_follow_up_date ? new Date(lead.next_follow_up_date).getTime() : 0;
  return urgency.rank * 1e13 + dateRank;
};
